<div class="onsight-form-input-select" *ngIf="myClass !== null" >
  <label>{{ myClass.langBase + label | translatePipe }}</label>
  <mat-form-field appearance="fill">
    <mat-select #sl [multiple]="true" class="form-control" placeholder="{{ 'commons.forms.select' | translatePipe }}"
                [(ngModel)]="myClass.model[name]" name="{{ name }}" [required]="required">
      <input placeholder="{{ 'commons.filter' | translatePipe }}" class="select-search" (keyup)="onKey($event, 'roleName')">
      <mat-option [value]="rg.userRoleID" *ngFor="let rg of list">{{ rg.roleName }}</mat-option>
      <button [disabled]="myClass.model[name].length == 0" (click)="sl.close()">Seleccionar</button>
    </mat-select>
  </mat-form-field>
</div>
